import styled from 'styled-components';
import OfferListItemTemplate from './OfferListTemplate';
import { rem } from 'polished';

export const OffersListStyled = styled(OfferListItemTemplate)``;
